import {
  CardStyleInterpolators,
  StackScreenProps,
} from "@react-navigation/stack";
import {
  ActionCreateProformaSaleRootParamList,
  ActionsRootParamList,
} from "../../../../types";
import {
  ModalCloseButton,
  createStackHeaderNavigator,
} from "@towersystems/roam-common-native";
import { useTranslation } from "../../../../utilities/i18n";
import { ListProformasScreen } from "./ListProformasScreen";
import { ViewProformaScreen } from "./ViewProformaScreen";

export interface ActionCreateProformaSaleRootScreenProps
  extends StackScreenProps<
    ActionsRootParamList & ActionCreateProformaSaleRootParamList,
    "ActionCreateProformaSaleRootScreen"
  > {}

export const ActionCreateProformaSaleRootScreen = ({
  navigation,
}: ActionCreateProformaSaleRootScreenProps) => {
  const { t } = useTranslation("pos");
  const Stack =
    createStackHeaderNavigator<ActionCreateProformaSaleRootParamList>();

  return (
    <Stack.Navigator
      screenOptions={{
        animationEnabled: true,
      }}
    >
      <Stack.Group
        screenOptions={{
          title: "",
          headerLeft: () => (
            <ModalCloseButton onPress={() => navigation.goBack()} type="Back" />
          ),
          cardStyleInterpolator: CardStyleInterpolators.forHorizontalIOS,
        }}
      >
        <Stack.Screen
          options={{
            headerShown: true,
          }}
          name="ListProformasScreen"
          component={ListProformasScreen}
        />
        <Stack.Screen
          options={{
            headerShown: true,
            headerLeft: () => (
              <ModalCloseButton
                onPress={() => navigation.navigate("ListProformasScreen")}
                type="Back"
              />
            ),
          }}
          name="ViewProformaScreen"
          component={ViewProformaScreen}
        />
      </Stack.Group>
    </Stack.Navigator>
  );
};
